export class Roles {
  static readonly ADMIN_BENCHMARK_CODE_UPDATE: string = "ROLE_ADMIN_BENCHMARK_CODE_UPDATE";
  static readonly VISIBILITY_PRIVATE_LIMIT_ORDERS: string = "ROLE_VISIBILITY_PRIVATE_LIMIT_ORDERS";
  static readonly VISIBILITY_PRIVATE_BENCHMARK_ORDERS: string =
    "ROLE_VISIBILITY_PRIVATE_BENCHMARK_ORDERS";
  static readonly ORDER_ENTRY: string = "ROLE_ORDER_ENTRY";
  static readonly USER: string = "ROLE_USER";
  static readonly FIX_TRADING: string = "ROLE_FIX_TRADING";
  static readonly ADMIN_BRANCHES: string = "ROLE_ADMIN_BRANCHES";
  static readonly ADMIN_BRANCHES_UPDATE: string = "ROLE_ADMIN_BRANCHES_UPDATE";
  static readonly ADMIN_CLIENTS: string = "ROLE_ADMIN_CLIENTS";
  static readonly ADMIN_CLIENTS_UPDATE: string = "ROLE_ADMIN_CLIENTS_UPDATE";
  static readonly ADMIN_CLIENTS_DELETE: string = "ROLE_ADMIN_CLIENTS_DELETE";
  static readonly ADMIN_ACCOUNTS: string = "ROLE_ADMIN_ACCOUNTS";
  static readonly ADMIN_ACCOUNTS_UPDATE: string = "ROLE_ADMIN_ACCOUNTS_UPDATE";
  static readonly ADMIN_ACCOUNTS_DELETE: string = "ROLE_ADMIN_ACCOUNTS_DELETE";
  static readonly ADMIN_BREAK_ACCOUNTS: string = "ROLE_ADMIN_BREAK_ACCOUNTS";
  static readonly ADMIN_BREAK_ACCOUNTS_UPDATE: string = "ROLE_ADMIN_BREAK_ACCOUNTS_UPDATE";
  static readonly ADMIN_BREAK_ACCOUNTS_DELETE: string = "ROLE_ADMIN_BREAK_ACCOUNTS_DELETE";
  static readonly ADMIN_USER_SETUP: string = "ROLE_ADMIN_USER_SETUP";
  static readonly ADMIN_USER_SETUP_UPDATE: string = "ROLE_ADMIN_USER_SETUP_UPDATE";
  static readonly ADMIN_SALES_GROUP: string = "ROLE_ADMIN_SALES_GROUP";
  static readonly ADMIN_SALES_GROUP_UPDATE: string = "ROLE_ADMIN_SALES_GROUP_UPDATE";
  static readonly ADMIN_TRADER_GROUP: string = "ROLE_ADMIN_TRADER_GROUP";
  static readonly ADMIN_TRADER_GROUP_UPDATE: string = "ROLE_ADMIN_TRADER_GROUP_UPDATE";
  static readonly ADMIN_CUT_OFF_GROUP: string = "ROLE_ADMIN_CUT_OFF_GROUP";
  static readonly ADMIN_CUT_OFF_GROUP_UPDATE: string = "ROLE_ADMIN_CUT_OFF_GROUP_UPDATE";
  static readonly ADMIN_PRIVILEGE_GROUPS: string = "ROLE_ADMIN_PRIVILEGE_GROUPS";
  static readonly ADMIN_PRIVILEGE_GROUPS_UPDATE: string = "ROLE_ADMIN_PRIVILEGE_GROUPS_UPDATE";
  static readonly ADMIN_CURRENCY: string = "ROLE_ADMIN_CURRENCY";
  static readonly ADMIN_CURRENCY_UPDATE: string = "ROLE_ADMIN_CURRENCY_UPDATE";
  static readonly ADMIN_CURRENCY_PAIR: string = "ROLE_ADMIN_CURRENCY_PAIR";
  static readonly ADMIN_CURRENCY_PAIR_UPDATE: string = "ROLE_ADMIN_CURRENCY_PAIR_UPDATE";
  static readonly ADMIN_CALENDARS: string = "ROLE_ADMIN_CALENDARS";
  static readonly ADMIN_CALENDARS_UPDATE: string = "ROLE_ADMIN_CALENDARS_UPDATE";
  static readonly ADMIN_MARKET_TIMES: string = "ROLE_ADMIN_MARKET_TIMES";
  static readonly ADMIN_MARKET_TIMES_UPDATE: string = "ROLE_ADMIN_MARKET_TIMES_UPDATE";
  static readonly ADMIN_ACCEPTANCE_CONTROLS: string = "ROLE_ADMIN_ACCEPTANCE_CONTROLS";
  static readonly ADMIN_ACCEPTANCE_CONTROLS_UPDATE: string =
    "ROLE_ADMIN_ACCEPTANCE_CONTROLS_UPDATE";
  static readonly ADMIN_AUTO_FILL_CONTROLS: string = "ROLE_ADMIN_AUTO_FILL_CONTROLS";
  static readonly ADMIN_AUTO_FILL_CONTROLS_UPDATE: string = "ROLE_ADMIN_AUTO_FILL_CONTROLS_UPDATE";
  static readonly ADMIN_SL_SLIPPAGES: string = "ROLE_ADMIN_SL_SLIPPAGES";
  static readonly ADMIN_SL_SLIPPAGES_UPDATE: string = "ROLE_ADMIN_SL_SLIPPAGES_UPDATE";
  static readonly ADMIN_CURRENCY_PAIR_GROUP_UPDATE: string =
    "ROLE_ADMIN_CURRENCY_PAIR_GROUP_UPDATE";
  static readonly ADMIN_RATE_SOURCE_MANAGEMENT: string = "ROLE_ADMIN_RATE_SOURCE_MANAGEMENT";
  static readonly ADMIN_RATE_SOURCE_MANAGEMENT_UPDATE: string =
    "ROLE_ADMIN_RATE_SOURCE_MANAGEMENT_UPDATE";
  static readonly ADMIN_MARKUP_PROFILES: string = "ROLE_ADMIN_MARKUP_PROFILES";
  static readonly ADMIN_CLIENT_TRADING_PERMISSIONS: string =
    "ROLE_ADMIN_CLIENT_TRADING_PERMISSIONS";
  static readonly ADMIN_CLIENT_TRADING_PERMISSIONS_UPDATE: string =
    "ROLE_ADMIN_CLIENT_TRADING_PERMISSIONS_UPDATE";
  static readonly ADMIN_USER_TRADING_PERMISSIONS: string = "ROLE_ADMIN_USER_TRADING_PERMISSIONS";
  static readonly ADMIN_USER_TRADING_PERMISSIONS_UPDATE: string =
    "ROLE_ADMIN_USER_TRADING_PERMISSIONS_UPDATE";
  static readonly ADMIN_BENCHMARK_PRICING_PROFILE: string = "ROLE_ADMIN_BENCHMARK_PRICING_PROFILE";
  static readonly ADMIN_BENCHMARK_PRICING_PROFILE_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_PRICING_PROFILE_UPDATE";
  static readonly ADMIN_VISIBILITY_PROFILES: string = "ROLE_ADMIN_VISIBILITY_PROFILES";
  static readonly ADMIN_VISIBILITY_PROFILES_UPDATE: string =
    "ROLE_ADMIN_VISIBILITY_PROFILES_UPDATE";
  static readonly ADMIN_LIMIT_AUTO_REJECT_RULES: string = "ROLE_ADMIN_LIMIT_AUTO_REJECT_RULES";
  static readonly ADMIN_LIMIT_AUTO_REJECT_RULES_UPDATE: string =
    "ROLE_ADMIN_LIMIT_AUTO_REJECT_RULES_UPDATE";
  static readonly ADMIN_BENCHMARK_AUTO_REJECT_RULES: string =
    "ROLE_ADMIN_BENCHMARK_AUTO_REJECT_RULES";
  static readonly ADMIN_BENCHMARK_AUTO_REJECT_RULES_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_AUTO_REJECT_RULES_UPDATE";
  static readonly ADMIN_ALGO_AUTO_REJECT_RULES: string = "ROLE_ADMIN_ALGO_AUTO_REJECT_RULES";
  static readonly ADMIN_ALGO_AUTO_REJECT_RULES_UPDATE: string =
    "ROLE_ADMIN_ALGO_AUTO_REJECT_RULES_UPDATE";
  static readonly ADMIN_BENCHMARK_ACCEPTANCE_CONTROLS: string =
    "ROLE_ADMIN_BENCHMARK_ACCEPTANCE_CONTROLS";
  static readonly ADMIN_BENCHMARK_ACCEPTANCE_CONTROLS_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_ACCEPTANCE_CONTROLS_UPDATE";
  static readonly ADMIN_LIMIT_ACCEPTANCE_CONTROLS: string = "ROLE_ADMIN_LIMIT_ACCEPTANCE_CONTROLS";
  static readonly ADMIN_LIMIT_ACCEPTANCE_CONTROLS_UPDATE: string =
    "ROLE_ADMIN_LIMIT_ACCEPTANCE_CONTROLS_UPDATE";
  static readonly ADMIN_ALGO_ACCEPTANCE_CONTROLS: string = "ROLE_ADMIN_ALGO_ACCEPTANCE_CONTROLS";
  static readonly ADMIN_ALGO_ACCEPTANCE_CONTROLS_UPDATE: string =
    "ROLE_ADMIN_ALGO_ACCEPTANCE_CONTROLS_UPDATE";
  static readonly ADMIN_BM_ALGO_HEDGING_PROFILES: string = "ROLE_ADMIN_BM_ALGO_HEDGING_PROFILES";
  static readonly ADMIN_BM_ALGO_HEDGING_PROFILES_UPDATE: string =
    "ROLE_ADMIN_BM_ALGO_HEDGING_PROFILES_UPDATE";
  static readonly ADMIN_DEFAULT_BM_ALGO_HEDGING_PROFILES: string =
    "ROLE_ADMIN_DEFAULT_BM_ALGO_HEDGING_PROFILES";
  static readonly ADMIN_DEFAULT_BM_ALGO_HEDGING_PROFILES_UPDATE: string =
    "ROLE_ADMIN_DEFAULT_BM_ALGO_HEDGING_PROFILES_UPDATE";
  static readonly ADMIN_BENCHMARK_AUTO_HEDGING: string = "ROLE_ADMIN_BENCHMARK_AUTO_HEDGING";
  static readonly ADMIN_BENCHMARK_AUTO_HEDGING_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_AUTO_HEDGING_UPDATE";
  static readonly SETTINGS_ACCEPTANCE_CONTROLS_UPDATE: string =
    "ROLE_SETTINGS_ACCEPTANCE_CONTROLS_UPDATE";
  static readonly SETTINGS_ACCEPTANCE_CONTROLS: string = "ROLE_SETTINGS_ACCEPTANCE_CONTROLS";
  static readonly ADMIN_MANUAL_OWNERSHIP: string = "ROLE_ADMIN_MANUAL_OWNERSHIP";
  static readonly ADMIN_MANUAL_OWNERSHIP_UPDATE: string = "ROLE_ADMIN_MANUAL_OWNERSHIP_UPDATE";
  static readonly ADMIN_BENCHMARK_CODE: string = "ROLE_ADMIN_BENCHMARK_CODE";
  static readonly ADMIN_CLIENT_SETTINGS: string = "ROLE_ADMIN_CLIENT_SETTINGS";
  static readonly ADMIN_CLIENT_SETTINGS_UPDATE: string = "ROLE_ADMIN_CLIENT_SETTINGS_UPDATE";
  static readonly ADMIN_CREATE_PUBLIC_FILTERS: string = "ROLE_ADMIN_CREATE_PUBLIC_FILTERS";
  static readonly ADMIN_FILTER_UNRESTRICTED: string = "ROLE_ADMIN_FILTER_UNRESTRICTED";
  static readonly ADMIN_NDF_FIXING_CODE: string = "ROLE_ADMIN_NDF_FIXING_CODE";
  static readonly ADMIN_NDF_FIXING_CODE_UPDATE: string = "ROLE_ADMIN_NDF_FIXING_CODE_UPDATE";
  static readonly ADMIN_PANIC: string = "ROLE_ADMIN_PANIC";
  static readonly DEAL_ACK: string = "ROLE_DEAL_ACK";
  static readonly DEAL_CANCEL: string = "ROLE_DEAL_CANCEL";
  static readonly ORDER_BENCHMARK_MANUAL_RISK_ROUTE: string =
    "ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE";
  static readonly ORDER_BENCHMARK_MANUAL_RISK_ROUTE_FROM_DEALT: string =
    "ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE_FROM_DEALT";
  static readonly ORDER_CANCEL: string = "ROLE_ORDER_CANCEL";
  static readonly ORDER_CANCEL_CROSS_CLIENT: string = "ROLE_ORDER_CANCEL_CROSS_CLIENT";
  static readonly ORDER_CANCEL_BM_HEDGE: string = "ROLE_ORDER_CANCEL_BM_HEDGE";
  static readonly ORDER_ENTRY_MARKUP_LIMIT: string = "ROLE_ORDER_ENTRY_MARKUP_LIMIT";
  static readonly ORDER_ENTRY_MARKUP_ALGO: string = "ROLE_ORDER_ENTRY_MARKUP_ALGO";
  static readonly ORDER_ENTRY_MARKUP_BENCHMARK: string = "ROLE_ORDER_ENTRY_MARKUP_BENCHMARK";
  static readonly ORDER_ENTRY_UNRESTRICTED: string = "ROLE_ORDER_ENTRY_UNRESTRICTED";
  static readonly ORDER_ENTRY_CONTACTS_MANAGER_UPDATE: string =
    "ROLE_ORDER_ENTRY_CONTACTS_MANAGER_UPDATE";
  static readonly ORDER_EXTERNAL_FORCE_STEAL: string = "ROLE_ORDER_EXTERNAL_FORCE_STEAL";
  static readonly ORDER_FILL: string = "ROLE_ORDER_FILL";
  static readonly ORDER_FILL_STP_OVERRIDE: string = "ROLE_ORDER_FILL_STP_OVERRIDE";
  static readonly ORDER_MODIFY: string = "ROLE_ORDER_MODIFY";
  static readonly ORDER_MODIFY_TRIGGERED: string = "ROLE_ORDER_MODIFY_TRIGGERED";
  static readonly ORDER_REACTIVATE: string = "ROLE_ORDER_REACTIVATE";
  static readonly ORDER_REQUEST_NDF_CUSTOM_FIXING: string = "ROLE_ORDER_REQUEST_NDF_CUSTOM_FIXING";
  static readonly ORDER_REQUEST_NDF_ODD_FIXING: string = "ROLE_ORDER_REQUEST_NDF_ODD_FIXING";
  static readonly ORDER_STEAL_FROM_AUTO: string = "ROLE_ORDER_STEAL_FROM_AUTO";
  static readonly ORDER_STEAL_FROM_MANUAL: string = "ROLE_ORDER_STEAL_FROM_MANUAL";
  static readonly ORDER_TRANSFER: string = "ROLE_ORDER_TRANSFER";
  static readonly ORDER_EXTERNAL_TRANSFER_ABORT: string = "ROLE_ORDER_EXTERNAL_TRANSFER_ABORT";
  static readonly ADMIN_CURRENCY_PAIR_GROUP: string = "ROLE_ADMIN_CURRENCY_PAIR_GROUP";
  static readonly ADMIN_MARKUP_PROFILES_UPDATE: string = "ROLE_ADMIN_MARKUP_PROFILES_UPDATE";
  static readonly ADMIN_BENCHMARK_RISK_ROUTING: string = "ROLE_ADMIN_BENCHMARK_RISK_ROUTING";
  static readonly ADMIN_BENCHMARK_RISK_ROUTING_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_RISK_ROUTING_UPDATE";
  static readonly ADMIN_BENCHMARK_OWNERSHIP: string = "ROLE_ADMIN_BENCHMARK_OWNERSHIP";
  static readonly ADMIN_BENCHMARK_OWNERSHIP_UPDATE: string =
    "ROLE_ADMIN_BENCHMARK_OWNERSHIP_UPDATE";
  // static readonly VIEW_BENCHMARK_SUMMARY_ORDERS: string = "ROLE_VIEW_BENCHMARK_SUMMARY_ORDERS";
  // static readonly VIEW_BENCHMARK_SUMMARY_RISK: string = "ROLE_VIEW_BENCHMARK_SUMMARY_RISK";
  static readonly ORDER_TRANSFER_UNRESTRICTED: string = "ROLE_ORDER_TRANSFER_UNRESTRICTED";
  static readonly ORDER_UNLOCK: string = "ROLE_ORDER_UNLOCK";
  static readonly ORDER_UNRESTRICTED_CANCEL_AND_MODIFY: string =
    "ROLE_ORDER_UNRESTRICTED_CANCEL_AND_MODIFY";
  static readonly VIEW_ACTIVE_BENCHMARKS: string = "ROLE_VIEW_ACTIVE_BENCHMARKS";
  static readonly VIEW_BENCHMARK_SUMMARY: string = "ROLE_VIEW_BENCHMARK_SUMMARY";
  static readonly VIEW_FILLS_BLOTTER: string = "ROLE_VIEW_FILLS_BLOTTER";
  static readonly VIEW_FIND_ORDERS: string = "ROLE_VIEW_FIND_ORDERS";
  static readonly VIEW_OPERATIONS_INTERVENTION: string = "ROLE_VIEW_OPERATIONS_INTERVENTION";
  static readonly VIEW_ORDER_ENTRY: string = "ROLE_VIEW_ORDER_ENTRY";
  static readonly VIEW_ORDER_BOOK: string = "ROLE_VIEW_ORDER_BOOK";
  static readonly VIEW_ALGO_MONITOR: string = "ROLE_VIEW_ALGO_MONITOR";
  static readonly VIEW_QUOTE_BOOK: string = "ROLE_VIEW_QUOTE_BOOK";
  static readonly VIEW_SCRATCHPAD: string = "ROLE_VIEW_SCRATCHPAD";
  static readonly VIEW_SESSION_ACTIVITY: string = "ROLE_VIEW_SESSION_ACTIVITY";
  static readonly VIEW_RISK_TRADE_BLOTTER: string = "ROLE_VIEW_RISK_TRADE_BLOTTER";
  static readonly VISIBILITY_HUB: string = "ROLE_VISIBILITY_HUB";
  static readonly VISIBILITY_PRIVATE_TRADER_GROUPS: string =
    "ROLE_VISIBILITY_PRIVATE_TRADER_GROUPS";
  static readonly VISIBILITY_UNLIMITED: string = "ROLE_VISIBILITY_UNLIMITED";
  static readonly ADMIN_SYSTEM_CONFIGS: string = "ROLE_ADMIN_SYSTEM_CONFIGS";
  static readonly ADMIN_SYSTEM_CONFIGS_UPDATE: string = "ROLE_ADMIN_SYSTEM_CONFIGS_UPDATE";
  static readonly ADMIN_AUTO_FILL_CLIENT_PROFILE: string = "ROLE_ADMIN_AUTO_FILL_CLIENT_PROFILE";
  static readonly ADMIN_AUTO_FILL_CLIENT_PROFILE_UPDATE: string =
    "ROLE_ADMIN_AUTO_FILL_CLIENT_PROFILE_UPDATE";
  static readonly ADMIN_RATE_SOURCE_PROFILE: string = "ROLE_ADMIN_RATE_SOURCE_PROFILE";
  static readonly ADMIN_RATE_SOURCE_PROFILE_UPDATE: string =
    "ROLE_ADMIN_RATE_SOURCE_PROFILE_UPDATE";
  static readonly ADMIN_AUTO_FILL_OWNERSHIP: string = "ROLE_ADMIN_AUTO_FILL_OWNERSHIP";
  static readonly ADMIN_AUTO_FILL_OWNERSHIP_UPDATE: string =
    "ROLE_ADMIN_AUTO_FILL_OWNERSHIP_UPDATE";
  static readonly ADD_FILL_COMMENT: string = "ROLE_ADD_FILL_COMMENT";
  static readonly ADMIN_TRADING_PERMISSIONS_PROFILES: string =
    "ROLE_ADMIN_TRADING_PERMISSIONS_PROFILES";
  static readonly ADMIN_TRADING_PERMISSIONS_PROFILES_UPDATE: string =
    "ROLE_ADMIN_TRADING_PERMISSIONS_PROFILES_UPDATE";
  static readonly VIEW_DEALER_INTERVENTION: string = "ROLE_VIEW_DEALER_INTERVENTION";
  static readonly ORDER_FIX_RATE: string = "ROLE_ORDER_FIX_RATE";
  static readonly VIEW_INBOX: string = "ROLE_VIEW_INBOX";
  static readonly VIEW_FIND_DEALS: string = "ROLE_VIEW_FIND_DEALS";
  static readonly VIEW_FIND_LIVE_ORDERS: string = "ROLE_VIEW_FIND_LIVE_ORDERS";
  static readonly ROLE_ORDER_PAUSE_RESUME: string = "ROLE_ORDER_PAUSE_RESUME";
  static readonly ROLE_ORDER_MODIFY_TRADER_GROUP_LIMIT: string =
    "ROLE_ORDER_MODIFY_TRADER_GROUP_LIMIT";
  static readonly ROLE_ORDER_MODIFY_TRADER_GROUP_ALGO: string =
    "ROLE_ORDER_MODIFY_TRADER_GROUP_ALGO";
  static readonly ROLE_ORDER_MODIFY_TRADER_GROUP_BENCHMARK: string =
    "ROLE_ORDER_MODIFY_TRADER_GROUP_BENCHMARK";
  static readonly ROLE_ADMIN_PUBLIC_PROFILES: string = "ROLE_ADMIN_PUBLIC_PROFILES";
  static readonly ROLE_VIEW_BENCHMARK_SUMMARY_RISK: string = "ROLE_VIEW_BENCHMARK_SUMMARY_RISK";
  static readonly ROLE_VIEW_BENCHMARK_SUMMARY_ORDERS: string = "ROLE_VIEW_BENCHMARK_SUMMARY_ORDERS";
  static readonly ROLE_VIEW_BENCHMARK_SUMMARY_HEDGE: string = "ROLE_VIEW_BENCHMARK_SUMMARY_HEDGE";
  static readonly ROLE_VIEW_HEDGE_ORDER_MONITOR: string = "ROLE_VIEW_HEDGE_ORDER_MONITOR";
  static readonly ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE: string =
    "ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE";
  static readonly ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE_FROM_DEALT: string =
    "ROLE_ORDER_BENCHMARK_MANUAL_RISK_ROUTE_FROM_DEALT";
  static readonly ROLE_VIEW_CONNECTION_STATUS: string = "ROLE_VIEW_CONNECTION_STATUS";
  static readonly ROLE_ORDER_EXPORT_FOR_IMPORT: string = "ROLE_ORDER_EXPORT_FOR_IMPORT";
  static readonly ROLE_ORDER_ALGO_INFLIGHT: string = "ROLE_ORDER_ALGO_INFLIGHT";

  static readonly DI_APPROVE_FILL: string = "ROLE_DI_TRADER_APPROVE_FILL";
  static readonly DI_CANCEL_FILL: string = "ROLE_DI_TRADER_CANCEL_FILL";
  static readonly DI_CLEAR_FILL: string = "ROLE_DI_TRADER_CLEAR_FILL";
  static readonly DI_SALES_APPROVE: string = "ROLE_DI_SALES_APPROVE";
  static readonly DI_SALES_REJECT: string = "ROLE_DI_SALES_REJECT";
  static readonly DI_SALES_AMEND_MARKUP: string = "ROLE_DI_SALES_AMEND_MARKUP";
  static readonly DI_SALES_UNRESTRICTED: string = "ROLE_DI_SALES_UNRESTRICTED";
  static readonly DI_SALES_CLEAR: string = "ROLE_DI_SALES_CLEAR";
  static readonly DI_SALES_PRICE: string = "ROLE_DI_SALES_PRICE";
  static readonly DI_TRADER_ACCEPT: string = "ROLE_DI_TRADER_ACCEPT";
  static readonly DI_TRADER_REJECT: string = "ROLE_DI_TRADER_REJECT";
  static readonly DI_TRADER_TRANSFER: string = "ROLE_DI_TRADER_TRANSFER";
  static readonly DI_TRADER_UNRESTRICTED: string = "ROLE_DI_TRADER_UNRESTRICTED";
  static readonly DI_OPERATIONS_CANCEL: string = "ROLE_DI_OPERATIONS_CANCEL";
  static readonly DI_OPERATIONS_CLEAR: string = "ROLE_DI_OPERATIONS_CLEAR";
  static readonly DI_OPERATIONS_MIGRATE: string = "ROLE_DI_OPERATIONS_MIGRATE";
  static readonly DI_OPERATIONS_RESUBMIT: string = "ROLE_DI_OPERATIONS_RESUBMIT";
  static readonly DI_OPERATIONS_STOP: string = "ROLE_DI_OPERATIONS_STOP";
  static readonly ROLE_DI_OPERATIONS_CLEAR: string = "ROLE_DI_OPERATIONS_CLEAR";

  static readonly ROLE_ADMIN_ALGO_INFLIGHT_RULES: string = "ROLE_ADMIN_ALGO_INFLIGHT_RULES";
  static readonly ROLE_ADMIN_ALGO_INFLIGHT_RULES_UPDATE: string =
    "ROLE_ADMIN_ALGO_INFLIGHT_RULES_UPDATE";

  static readonly ROLE_ORDER_EXPORT: string = "ROLE_ORDER_EXPORT";
  static readonly ROLE_VISIBILITY_BENCHMARKS_PRE_VISIBILITY: string =
    "ROLE_VISIBILITY_BENCHMARKS_PRE_VISIBILITY";

  static readonly ROLE_ORDER_ENTRY_STP_AGGREGATION: string = "ROLE_ORDER_ENTRY_STP_AGGREGATION";
  static readonly ROLE_ORDER_MODIFY_FWD_PRICING: string = "ROLE_ORDER_MODIFY_FWD_PRICING";
  static readonly ROLE_ORDER_ALGO_DESIGNER: string = "ROLE_ORDER_ALGO_DESIGNER";
  static readonly ROLE_SETTINGS_EMAIL_SMS_UPDATE: string = "ROLE_SETTINGS_EMAIL_SMS_UPDATE";
  static readonly ROLE_VIEW_BENCHMARK_SUMMARY_AUDIT: string = "ROLE_VIEW_BENCHMARK_SUMMARY_AUDIT";
  static readonly ROLE_BM_AUTO_HEDGING_POSITION_CONTROL: string =
    "ROLE_BM_AUTO_HEDGING_POSITION_CONTROL";

  static readonly ROLE_BM_AUTO_HEDGING_CIRCUIT_BREAKER = "ROLE_BM_AUTO_HEDGING_CIRCUIT_BREAKER";
  static readonly ROLE_ORDER_ALGO_FILL_NOW = "ROLE_ORDER_ALGO_FILL_NOW";
  static readonly ROLE_ORDER_BENCHMARK_NETTING: string = "ROLE_ORDER_BENCHMARK_NETTING";
  static readonly ROLE_VIEW_BENCHMARK_SUMMARY_FWD: string = "ROLE_VIEW_BENCHMARK_SUMMARY_FWD";
}
